import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MatError } from '@angular/material/form-field';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'mat-form-error',
  templateUrl: './mat-form-error.component.html',
  host: {
    class: 'mat-error',
    role: 'alert',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoModule],
})
export class MatFormErrorComponent extends MatError {
  @Input() public control: AbstractControl | null;
  @Input() public label?: string;

  public hasError(error: string): boolean {
    return !!this.control?.hasError(error);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getError(error: string): any {
    const errors = this.control?.errors;

    return errors ? errors[error] : {};
  }
}
